"use client";
import { DM_Sans, Roboto } from "next/font/google";
import "./globals.scss";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
const Chatbot = dynamic(() => import("@/components/Chatbot"), { ssr: false });
import Popup, { usePopup } from "@/components/Popup";
import Loader from "@/components/Loader";
import { useState } from "react";
import dynamic from "next/dynamic";
import { heroData } from "./(home)/data/heroData";
import Link from "next/link";
import { FaWhatsapp } from "react-icons/fa";
import { Phone } from "lucide-react";

const dmSans = DM_Sans({
  variable: "--font-dm-sans",
  subsets: ["latin"],
  weight: ["400", "500", "700"],
  display: "swap",
});

const roboto = Roboto({
  variable: "--font-roboto",
  subsets: ["latin"],
  weight: ["400", "500", "700"],
  display: "swap",
});

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <html lang="en" suppressHydrationWarning>
      <head>
        <title>SATYANAM SOLAR</title>
        <meta name="description" content="..." />
        {heroData.map((data, i) => (
          <link
            key={i}
            rel="preload"
            href={data.imageUrl}
            as="image"
            {...(i > 0 ? { media: "(max-width: 1px)" } : {})}
          />
        ))}
      </head>
      <body
        className={`${dmSans.variable} ${roboto.variable} antialiased flex flex-col min-h-screen`}
      >
        {isLoading && <Loader onComplete={() => setIsLoading(false)} />}

        {!isLoading && (
          <>
            <Navbar />
            <main className="flex-grow">{children}</main>
            <Footer />
            <Chatbot />

            {/* ✅ WhatsApp Button */}
            <a
              href="https://wa.me/918484046484" // Replace with your number
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp Chat"
              className="fixed bottom-20 mb-1 right-6 bg-[#2BB440] text-white p-4 rounded-full shadow-lg hover:bg-pri-dark transition-all flex items-center justify-center z-20"
            >
              <FaWhatsapp size={20} />
            </a>

            {/* Contact Us Button */}
            <Link
              className="fixed bottom-6 right-6 bg-[#40204A] text-white p-4 rounded-full shadow-lg hover:bg-pri-dark transition-all flex items-center justify-center z-20"
              href="/#contact"
              aria-label="Contact Us"
            >
              <Phone size={20} className="text-color4" />
            </Link>
          </>
        )}
      </body>
    </html>
  );
}
